module.exports = __webpack_public_path__ + "static/img/012.cec9f9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-headquarters/012.png
// module id = CdJ8
// module chunks = 1